<template>
    <Component
        :is="componentInstance"
        v-bind="$attrs"
        :value="value"
        :get-data-vuex="getOffers"
        :placeholder="placeholder"
        :multiple="multiple"
        class="white"
        @[event]="$emit(event, $event)">
        <template #text="option">
            <OfferOutput :offer="option.option"></OfferOutput>
        </template>
        <template #selected-option="option">
            <OfferOutput :offer="option.option"></OfferOutput>
        </template>
    </Component>
</template>

<script>
  import { UsersSelect } from "@core/mixins/select/usersSelect";
  import OfferOutput from "@/components/Common/Output/OfferOutput.vue";

  export default {
    name: "SubAccountOffers",
    mixins: [UsersSelect],

    components: { OfferOutput },

    props: {
      routeParam: {
        type: String,
        default: "id"
      },
      namespaceModule: {
        type: String,
        default: "webmaster/subAccountOffers"
      },
      vertical: {
        type: [Boolean, String],
        default: false
      },
      seed: {
        type: null,
        default: null
      }
    },

    methods: {
      async getOffers (label = "", isLoading = false) {
        const { filterOptions, value, routeParam, namespaceModule } = this;
        await this.getOfferFilters(
          namespaceModule, this.list, this.$route.query[routeParam] ?? value,
          routeParam, label, isLoading, filterOptions
        );
        return this.list;
      }
    }
  };
</script>

<style scoped>

</style>
